import { render, staticRenderFns } from "./CmGallery.vue?vue&type=template&id=9204d814"
import script from "./CmGallery.vue?vue&type=script&lang=ts"
export * from "./CmGallery.vue?vue&type=script&lang=ts"
import style0 from "./CmGallery.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModuleHeader: require('/app/components/base/ModuleHeader/ModuleHeader.vue').default,ImageComponent: require('/app/components/base/ImageComponent/ImageComponent.vue').default})
